const baseStyle = {
    fontFamily: 'heading',
};
const sizes = {
    xl: { fontSize: '5xl', lineHeight: 'shorter', fontWeight: 'bold' },
    lg: { fontSize: '4xl', lineHeight: 'short', fontWeight: 'bold' },
    md: { fontSize: '3xl', lineHeight: 'short', fontWeight: 'semibold' },
    sm: { fontSize: '2xl', lineHeight: 'base', fontWeight: 'semibold' },
};
const defaultProps = {
    size: 'xl',
};
export default {
    baseStyle,
    sizes,
    defaultProps,
};
//# sourceMappingURL=heading.js.map